import {
  subscribeEvent,
  triggerEvent,
  unsubscribeEvent,
} from '@shared/event/event'
import type { ShoeSizeFinderEvent } from '@shared/event/events/types'
import type { EventCallback, EventToken } from '@shared/event/types'

const SIZE_FINDER_EVENT = 'shoe_size_finder'

export const triggerShoeSizeFinderEvent = (event: ShoeSizeFinderEvent) =>
  triggerEvent(SIZE_FINDER_EVENT, event)

export const onShoeSizeFinderEvent = (
  callback: EventCallback<ShoeSizeFinderEvent>
) => subscribeEvent(SIZE_FINDER_EVENT, callback)

export const removeShoeSizeFinderEvent = (
  token: EventToken<ShoeSizeFinderEvent>
) => unsubscribeEvent(SIZE_FINDER_EVENT, token)
